export function isObjectKeysNotEmpty(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
        return false
      }
      if (Array.isArray(obj[key]) && obj[key].length === 0) {
        return false
      }
    }
  }
  return true
}
